module.exports = __webpack_public_path__ + "img/trip-distance.3a54d47e.svg";